<template>
  <div>
    <h1 class="page-title">用户管理</h1>

    <div class="query-panel soft-card">
      <div class="query-fields">
        <el-input
          v-model="query.username"
          clearable
          placeholder="登录账号"
          class="query-control"
          @keyup.enter.native="search"
        />
        <el-input
          v-model="query.nickname"
          clearable
          placeholder="姓名 / 昵称"
          class="query-control"
          @keyup.enter.native="search"
        />
        <el-input
          v-model="query.phone"
          clearable
          placeholder="手机号"
          class="query-control"
          @keyup.enter.native="search"
        />
        <el-input
          v-model="query.companyName"
          clearable
          placeholder="企业名称"
          class="query-control"
          @keyup.enter.native="search"
        />
        <el-select v-model="query.userType" clearable placeholder="账号类型" class="query-control">
          <el-option label="运维账号" value="ops" />
          <el-option label="管理员" value="admin" />
          <el-option label="小程序用户" value="member" />
        </el-select>
        <el-select v-model="query.status" clearable placeholder="状态" class="query-control">
          <el-option label="启用" :value="1" />
          <el-option label="停用" :value="0" />
        </el-select>
      </div>
      <div class="query-actions">
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh-left" @click="resetQuery">重置</el-button>
      </div>
    </div>

    <div class="page-actions">
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增账号</el-button>
    </div>

    <el-table class="soft-card" :data="list" v-loading="loading">
      <el-table-column type="index" label="序号" width="70" :index="tableIndex" />
      <el-table-column prop="username" label="账号" min-width="130" />
      <el-table-column prop="userType" label="类型" width="110">
        <template slot-scope="scope">
          <el-tag :type="typeTag(scope.row.userType)">{{ typeLabel(scope.row.userType) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="姓名/昵称" min-width="120" />
      <el-table-column prop="phone" label="手机号" min-width="130" />
      <el-table-column prop="companyName" label="企业名称" min-width="180" show-overflow-tooltip />
      <el-table-column label="状态" width="90">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">{{ scope.row.status === 1 ? '启用' : '停用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="230" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="openEdit(scope.row.id)">编辑</el-button>
          <el-button type="text" size="mini" @click="openReset(scope.row)">重置密码</el-button>
          <el-button
            v-if="scope.row.userType !== 'ops'"
            type="text"
            size="mini"
            class="danger-text"
            @click="remove(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-wrap">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page="query.pageNum"
        :page-size="query.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </div>

    <el-dialog
      :close-on-click-modal="false"
      v-if="visible"
      custom-class="manage-dialog"
      :title="dialogTitle"
      :visible.sync="visible"
      width="900px"
      top="5vh"
    >
      <el-form ref="userForm" class="manage-form" :model="form" :rules="rules" label-width="120px" v-loading="detailLoading">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="账号类型" prop="userType">
              <el-select v-model="form.userType" :disabled="form.userType === 'ops'" placeholder="请选择账号类型">
                <el-option label="运维账号" value="ops" disabled />
                <el-option label="管理员" value="admin" />
                <el-option label="小程序用户" value="member" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="登录账号" prop="username">
              <el-input v-model="form.username" :disabled="!!form.id" clearable />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" v-if="!form.id">
          <el-col :span="12">
            <el-form-item label="初始密码" prop="password">
              <el-input v-model="form.password" show-password clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-switch v-model="enabled" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="状态" v-else>
          <el-switch v-model="enabled" :disabled="form.userType === 'ops'" />
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名/昵称">
              <el-input v-model="form.nickname" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号">
              <el-input v-model="form.phone" clearable />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="性别">
              <el-select v-model="form.gender" clearable placeholder="请选择">
                <el-option label="男" value="男" />
                <el-option label="女" value="女" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业名称">
              <el-input v-model="form.companyName" clearable />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业联系人">
              <el-input v-model="form.contactName" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业联系电话">
              <el-input v-model="form.contactPhone" clearable />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="职务">
              <el-input v-model="form.position" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属行业">
              <el-input v-model="form.industry" clearable />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="企业地址">
          <el-input v-model="form.companyAddress" clearable />
        </el-form-item>
        <el-form-item label="主营业务">
          <el-input v-model="form.businessScope" type="textarea" :rows="3" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :disabled="detailLoading" @click="save">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      v-if="resetVisible"
      custom-class="manage-dialog"
      title="重置密码"
      :visible.sync="resetVisible"
      width="480px"
    >
      <el-form ref="resetForm" :model="resetForm" :rules="resetRules" label-width="100px">
        <el-form-item label="账号">
          <el-input :value="resetTarget ? resetTarget.username : ''" disabled />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="resetForm.newPassword" show-password clearable />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="resetVisible = false">取消</el-button>
        <el-button type="primary" @click="resetPassword">确认重置</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { listUsers, detailUser, saveUser, resetUserPassword, deleteUser } from '../api'

const empty = () => ({
  id: null,
  userType: 'member',
  username: '',
  password: '',
  nickname: '',
  phone: '',
  gender: '',
  companyName: '',
  contactName: '',
  contactPhone: '',
  position: '',
  industry: '',
  companyAddress: '',
  businessScope: '',
  status: 1
})

export default {
  data() {
    return {
      query: {
        username: '',
        nickname: '',
        phone: '',
        companyName: '',
        userType: '',
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      list: [],
      total: 0,
      loading: false,
      visible: false,
      detailLoading: false,
      editingId: null,
      form: empty(),
      resetVisible: false,
      resetTarget: null,
      resetForm: { newPassword: '' },
      rules: {
        userType: [{ required: true, message: '请选择账号类型', trigger: 'change' }],
        username: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
        password: [{ required: true, min: 6, message: '初始密码至少6位', trigger: 'blur' }]
      },
      resetRules: {
        newPassword: [{ required: true, min: 6, message: '新密码至少6位', trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.editingId ? '编辑账号' : '新增账号'
    },
    enabled: {
      get() { return this.form.status === 1 },
      set(value) { this.form.status = value ? 1 : 0 }
    }
  },
  created() { this.load() },
  methods: {
    load() {
      this.loading = true
      listUsers(this.query).then(result => {
        this.list = result && result.records ? result.records : []
        this.total = result && typeof result.total === 'number' ? result.total : 0
      }).finally(() => { this.loading = false })
    },
    search() { this.query.pageNum = 1; this.load() },
    resetQuery() {
      this.query.username = ''
      this.query.nickname = ''
      this.query.phone = ''
      this.query.companyName = ''
      this.query.userType = ''
      this.query.status = null
      this.query.pageNum = 1
      this.load()
    },
    tableIndex(index) { return (this.query.pageNum - 1) * this.query.pageSize + index + 1 },
    handlePageChange(pageNum) { this.query.pageNum = pageNum; this.load() },
    handleSizeChange(pageSize) { this.query.pageSize = pageSize; this.query.pageNum = 1; this.load() },
    typeLabel(type) {
      return { ops: '运维账号', admin: '管理员', member: '小程序用户' }[type] || type
    },
    typeTag(type) {
      return { ops: 'warning', admin: 'primary', member: 'success' }[type] || 'info'
    },
    openEdit(id) {
      this.editingId = id || null
      this.form = empty()
      this.visible = true
      this.$nextTick(() => { if (this.$refs.userForm) this.$refs.userForm.clearValidate() })
      if (!id) return
      this.detailLoading = true
      detailUser({ id }).then(result => {
        this.form = Object.assign(empty(), result, { password: '' })
        this.$nextTick(() => { if (this.$refs.userForm) this.$refs.userForm.clearValidate() })
      }).finally(() => { this.detailLoading = false })
    },
    save() {
      this.$refs.userForm.validate(valid => {
        if (!valid) return
        saveUser(this.form).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.load()
        })
      })
    },
    openReset(row) {
      this.resetTarget = row
      this.resetForm = { newPassword: '' }
      this.resetVisible = true
      this.$nextTick(() => { if (this.$refs.resetForm) this.$refs.resetForm.clearValidate() })
    },
    resetPassword() {
      this.$refs.resetForm.validate(valid => {
        if (!valid) return
        resetUserPassword({ id: this.resetTarget.id, newPassword: this.resetForm.newPassword }).then(() => {
          this.$message.success('密码已重置')
          this.resetVisible = false
        })
      })
    },
    remove(row) {
      this.$confirm('确认删除该账号吗？删除后不可恢复。', '删除确认', { type: 'warning' })
        .then(() => deleteUser({ id: row.id }))
        .then(() => {
          this.$message.success('已删除')
          if (this.list.length === 1 && this.query.pageNum > 1) this.query.pageNum -= 1
          this.load()
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.pagination-wrap {
  display: flex;
  justify-content: flex-end;
  margin: 18px 0 4px;
}

.query-panel {
  padding: 18px;
  margin-bottom: 14px;
}

.query-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.query-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
}

.page-actions {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 16px;
}

.query-control {
  width: 220px;
}


.danger-text {
  color: #f56c6c;
}

.manage-form .el-select,
.manage-form .el-input,
.manage-form .el-input-number {
  width: 100%;
}

.manage-form ::v-deep .el-form-item__label {
  white-space: nowrap;
}
</style>
